/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyImpactTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAnomalyImpactTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostAnomalyImpactTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyImpactTrendWidgetConfiguration>): CostAnomalyImpactTrendWidgetConfiguration {
        let obj = Object.assign(new CostAnomalyImpactTrendWidgetConfiguration(), model);
        CostAnomalyImpactTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyImpactTrendWidgetConfiguration>): CostAnomalyImpactTrendWidgetConfiguration {
        if (!model) return null;
        return CostAnomalyImpactTrendWidgetConfiguration.newInstance(<CostAnomalyImpactTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyImpactTrendWidgetConfiguration) {
        if (!obj) return;

        models.CostAnomalyImpactTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyImpactTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalyImpactTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
